var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ll-link"},[_c('a',{staticClass:"link",on:{"click":function($event){$event.stopPropagation();return _vm.$_onClick.apply(null, arguments)}}},[_c('span',{staticClass:"ll-link__text"},[_vm._v(" "+_vm._s(_vm.textLabel)+" ")]),_c('i',{staticClass:"icon-link ll-link__icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }